import {
  FairValueByCompanyBarChartsData,
} from '../organization/components/fair-value-and-pp-charts/service/calculations-service/fair-value-and-pp-charts.service';

export interface GroupedPortfolio {
  [category: string]: CategoryData;
}

export interface CategoryData {
  name: string;
  data: FairValueByCompanyBarChartsData[];
}

export class DrilldownCompanyData {
  name: string;
  id: number;
}

export interface CombinedDrilldownPortfolio {
  name: string;
  sum: number;
  investment: DrilldownData;
  gain: DrilldownData;
  moic: DrilldownData;
}

export class PortfoliosPerformanceBarChartData {
  mainData: CombinedDrilldownPortfolio[];
  drilldownData: GroupedPortfolio;
}

export interface DrilldownData {
  y: number;
  drilldown: string;
}
